import $ from 'jquery'

export default function hideLoading() {
  const loading = document.querySelector('#loading')
  if (!loading) return

  loading.style.display = 'none'

  $('[data-toggle="tooltip"]').tooltip()
}
